import { render, staticRenderFns } from "./EditStandaloneEvent.vue?vue&type=template&id=3044f488&scoped=true&"
import script from "./EditStandaloneEvent.vue?vue&type=script&lang=js&"
export * from "./EditStandaloneEvent.vue?vue&type=script&lang=js&"
import style0 from "./EditStandaloneEvent.vue?vue&type=style&index=0&id=3044f488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3044f488",
  null
  
)

export default component.exports